import { Record } from 'immutable';

export const mkBuild = Record({
  bugsnag_api_key: 'unknown',
  bugsnag_release_stage: 'unknown',
  cobrowse_license: 'unknown',
  community_url: 'unknown',
  user_guide_url: 'unknown',
  finicity_env: 'unknown',
  hotjar_key: null as number | null,
  inactivity_countdown_timeout_in_seconds: 30,
  inactivity_timeout_in_seconds: 900,
  ld_client_id: 'unknown',
  mixpanel_token: 'unknown',
  plaid_env: 'unknown',
  sso_client_id: 'unknown',
  stripe_mode: 'unknown',
  mixpanelProxy: '',
});
export type BuildConfig = ReturnType<typeof mkBuild>;

export const mkClient = Record({
  product: 'unknown',
  product_name: 'unknown',
  app_version: 'unknown',
  build: 'unknown',
  commit: 'unknown',
  build_type: 'unknown',
  environment: 'unknown',
  protocol: 'unknown',
  hostname: 'unknown',
  port: 'unknown',
});
export type ClientConfig = ReturnType<typeof mkClient>;

export const mkCommon = Record({
  handle_retry: undefined as boolean | undefined,
  mui_x_pro_license: '',
  pendo_api_key: 'unknown',
  plaid_client_name: 'unknown',
  plaid_product: 'unknown' as string | readonly string[],
  plaid_public_key: 'unknown',
  stripe_client_id_live: 'unknown',
  stripe_client_id_test: 'unknown',
  stripe_public_key_live: 'unknown',
  stripe_public_key_test: 'unknown',
  external: {} as { readonly [link: string]: string | undefined },
});
export type CommonConfig = ReturnType<typeof mkCommon>;

export const mkEnvironment = Record({
  intercom_app_id: 'unknown',
  client_id: 'unknown',
  client_secret: 'unknown',
  firebase_api_key: 'unknown',
  firebase_app_id: 'unknown',
  firebase_messaging_sender_id: 'unknown',
  firebase_project_id: 'unknown',
  myaccount_url: 'unknown',
  pick_your_plan_url: 'unknown',
  plaid_webhook: 'unknown',
  services_url: 'unknown',
  signature_public_key: 'unknown',
  signin_url: 'unknown',
  websocket_qcs_url: 'unknown',
});
export type EnvironmentConfig = ReturnType<typeof mkEnvironment>;

export const mkHost = Record({
  demo_app: undefined as string | undefined,
  storybook: undefined as string | undefined,
  environment_default: undefined as string | undefined,
  homepage_url: undefined as string | undefined,
  redirect_uri: undefined as string | undefined,
});
export type HostConfig = ReturnType<typeof mkHost>;

export const mkConfig = Record({
  builds: null as { readonly [buildType: string]: BuildConfig | undefined } | null,
  client: null as ClientConfig | null,
  common: null as CommonConfig | null,
  environments: null as { readonly [environment: string]: EnvironmentConfig | undefined } | null,
  hosts: null as { readonly [hostname: string]: HostConfig | undefined } | null,
});
export type Config = ReturnType<typeof mkConfig>;
